import type { CandleWithFlag } from "features/chart";

export interface BollingerBandsLines {
  upper: (number | null)[];
  middle: (number | null)[];
  lower: (number | null)[];
}

export function calcBollingerBands(
  data: CandleWithFlag[],
  period: number,
  deviation: number,
): BollingerBandsLines {
  const n = data.length;
  const upper: (number | null)[] = new Array(n).fill(null);
  const middle: (number | null)[] = new Array(n).fill(null);
  const lower: (number | null)[] = new Array(n).fill(null);

  for (let i = period - 1; i < n; i++) {
    let sum = 0;
    for (let j = i - period + 1; j <= i; j++) sum += data[j].close;
    const sma = sum / period;
    let variance = 0;
    for (let j = i - period + 1; j <= i; j++) {
      const diff = data[j].close - sma;
      variance += diff * diff;
    }
    const stddev = Math.sqrt(variance / period);
    middle[i] = sma;
    upper[i] = sma + deviation * stddev;
    lower[i] = sma - deviation * stddev;
  }

  return { upper, middle, lower };
}
